export default __webpack_public_path__ + "static/media/other9.ab040709.jpg";